if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.currentIndex = 0;
        this.mediaItems = [];
        this.isZoomed = false;
        // Disable swipe navigation on touch to avoid conflicts with zoom/pan
        this.allowSwipeNavigation = false;
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.scale = 1;
        this.lastTouchDistance = 0;
        this.tx = 0; // translateX for panning
        this.ty = 0; // translateY for panning
        this.isDragging = false;
        this.dragStartX = 0;
        this.dragStartY = 0;
    this.boundNavigate = this.handleNavigation.bind(this);
  this.hintHideTimeout = null;
  this.clickTimer = null;
  // Track pointer to avoid click-zoom after a drag
  this.isPointerDown = false;
  this.draggedSinceMouseDown = false;
  this.pointerDownX = 0;
  this.pointerDownY = 0;
    this.boundPointerHandler = this.handlePointerUp.bind(this);
        
        // Override the base modal's pointerup handler
        this.overrideBaseEvents();
      }

      overrideBaseEvents() {
        // Remove the existing pointerup listener by cloning the element
        // This is a hack to remove event listeners we can't access directly
        if (this.classList.contains('media-modal')) {
          // Add our own pointerup handler that accounts for navigation buttons
          this.addEventListener('pointerup', this.boundPointerHandler);
        }
      }

      handlePointerUp(event) {
        // Don't close if clicking on navigation buttons
        if (event.target.closest('[data-modal-nav]') || 
            event.target.closest('.product-media-modal__nav')) {
          return;
        }
        
        // Don't close if clicking on images (for zoom)
        if (event.target.closest('.active img')) {
          return;
        }
        
        // Original logic from base class but with our exceptions
        if (event.pointerType === 'mouse' && 
            !event.target.closest('deferred-media, product-model, [data-modal-nav], .product-media-modal__nav, .active img')) {
          this.hide();
        }
      }

      connectedCallback() {
        super.connectedCallback();
        this.initializeEventListeners();
      }

      handleNavigation(event) {
        const navButton = event.target.closest('[data-modal-nav]');
        if (navButton) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          
          const direction = navButton.getAttribute('data-modal-nav');
          this.navigate(direction);
          return false;
        }
      }

      initializeEventListeners() {
        // Use event delegation from the modal root - capture phase
        this.addEventListener('click', this.boundNavigate, true);
        
        // Also add to the document to catch it even earlier
        document.addEventListener('click', (event) => {
          if (this.hasAttribute('open')) {
            const navButton = event.target.closest('[data-modal-nav]');
            if (navButton && this.contains(navButton)) {
              event.preventDefault();
              event.stopPropagation();
              event.stopImmediatePropagation();
              
              const direction = navButton.getAttribute('data-modal-nav');
              this.navigate(direction);
              return false;
            }
          }
        }, true);

        // Keyboard navigation
        document.addEventListener('keydown', (e) => {
          if (!this.hasAttribute('open')) return;
          
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.navigate('prev');
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.navigate('next');
          }
        });

        // Touch events for mobile; disable zoom gestures on touch devices to avoid weird double interactions
        const content = this.querySelector('.product-media-modal__content');
        if (content) {
          const isTouch = window.matchMedia('(pointer: coarse)').matches || 'ontouchstart' in window || navigator.maxTouchPoints > 0;
          // Touch start
          content.addEventListener('touchstart', (e) => {
            if (isTouch) return; // disable zoom/swipe management on touch
            this.handleTouchStart(e);
          });

          // Touch move
          content.addEventListener('touchmove', (e) => {
            if (isTouch) return;
            this.handleTouchMove(e);
          });

          // Touch end
          content.addEventListener('touchend', (e) => {
            if (isTouch) return;
            this.handleTouchEnd(e);
          });

          // Double tap to zoom
          let lastTap = 0;
          if (!isTouch) {
            content.addEventListener('touchend', (e) => {
              const currentTime = new Date().getTime();
              const tapLength = currentTime - lastTap;
              if (tapLength < 500 && tapLength > 0) {
                this.toggleZoom(e);
                e.preventDefault();
              }
              lastTap = currentTime;
            });
          }

          // Desktop click to zoom-in (only once); dblclick to reset
          content.addEventListener('click', (e) => {
            const isTouchEnv = window.matchMedia('(pointer: coarse)').matches || 'ontouchstart' in window || navigator.maxTouchPoints > 0;
            if (isTouchEnv) return; // disable single-click zoom on mobile/touch
            const img = this.getActiveImage();
            const activeMedia = this.querySelector('[data-media-id].active');
            if (!activeMedia || !img) return;
            if (e.target.closest('[data-modal-nav], .product-media-modal__nav, .product-media-modal__toggle, .product-media-modal__cta, .product-media-modal__hint')) return;
            e.preventDefault();
            e.stopPropagation();
            // Suppress single-click zoom if a drag occurred since mousedown
            const wasDrag = this.draggedSinceMouseDown;
            this.draggedSinceMouseDown = false;
            if (wasDrag) return;
            // Only allow single-click zoom once; ignore further single clicks while zoomed
            if (this.isZoomed || this.scale > 1) return;
            const rect = content.getBoundingClientRect();
            const cx = e.clientX - rect.left - rect.width / 2;
            const cy = e.clientY - rect.top - rect.height / 2;
            if (this.clickTimer) clearTimeout(this.clickTimer);
            this.clickTimer = setTimeout(() => {
              this.zoomInAt(cx, cy);
              this.clickTimer = null;
            }, 220);
          });

          content.addEventListener('dblclick', (e) => {
            const isTouchEnv = window.matchMedia('(pointer: coarse)').matches || 'ontouchstart' in window || navigator.maxTouchPoints > 0;
            if (isTouchEnv) return; // disable double click zoom reset on touch
            const img = this.getActiveImage();
            const activeMedia = this.querySelector('[data-media-id].active');
            if (!activeMedia || !img) return;
            if (e.target.closest('[data-modal-nav], .product-media-modal__nav, .product-media-modal__toggle, .product-media-modal__cta')) return;
            e.preventDefault();
            e.stopPropagation();
            if (this.clickTimer) { clearTimeout(this.clickTimer); this.clickTimer = null; }
            if (this.scale > 1) {
              this.resetZoom();
            }
          });
          
          // Desktop wheel zoom
          content.addEventListener('wheel', (e) => {
            const isTouchEnv = window.matchMedia('(pointer: coarse)').matches || 'ontouchstart' in window || navigator.maxTouchPoints > 0;
            if (isTouchEnv) return; // disable wheel zoom on touch devices
            const img = this.getActiveImage();
            if (!img) return;
            e.preventDefault();
            e.stopPropagation();
            const rect = content.getBoundingClientRect();
            const cx = e.clientX - rect.left - rect.width / 2; // cursor rel to center
            const cy = e.clientY - rect.top - rect.height / 2;
            const prevScale = this.scale;
            const delta = e.deltaY > 0 ? -0.1 : 0.1;
            this.scale = Math.max(1, Math.min(3, this.scale + delta));
            if (this.scale > 1) {
              this.isZoomed = true;
              // Adjust pan towards cursor to create focal zoom effect
              const factor = this.scale / prevScale;
              this.tx = (this.tx - cx) * factor + cx;
              this.ty = (this.ty - cy) * factor + cy;
              this.clampPan();
              this.applyZoom();
            } else {
              this.resetZoom();
            }
          }, { passive: false });

          // Desktop pointer down + drag to pan when zoomed; also track drag to suppress click-zoom
          content.addEventListener('mousedown', (e) => {
            this.isPointerDown = true;
            this.draggedSinceMouseDown = false;
            this.pointerDownX = e.clientX;
            this.pointerDownY = e.clientY;
            const img = this.getActiveImage();
            if (!img || !this.isZoomed) return;
            e.preventDefault();
            this.isDragging = true;
            this.dragStartX = e.clientX;
            this.dragStartY = e.clientY;
            content.style.cursor = 'grabbing';
          });

          content.addEventListener('mousemove', (e) => {
            // Mark as drag if moved enough since mousedown
            if (this.isPointerDown) {
              const totalDx = Math.abs(e.clientX - this.pointerDownX);
              const totalDy = Math.abs(e.clientY - this.pointerDownY);
              if (totalDx > 5 || totalDy > 5) this.draggedSinceMouseDown = true;
            }
            if (!this.isDragging || !this.isZoomed) return;
            const dx = e.clientX - this.dragStartX;
            const dy = e.clientY - this.dragStartY;
            this.dragStartX = e.clientX;
            this.dragStartY = e.clientY;
            this.tx += dx;
            this.ty += dy;
            this.clampPan();
            // During drag, avoid transition
            const img = this.getActiveImage();
            if (img) img.style.transition = 'none';
            this.applyZoom();
          });

          const endDrag = () => {
            if (!this.isDragging) return;
            this.isDragging = false;
            content.style.cursor = '';
            // Restore transition for smoother subsequent transforms
            const img = this.getActiveImage();
            if (img) img.style.transition = 'transform 0.3s ease';
          };

          content.addEventListener('mouseup', (e) => {
            this.isPointerDown = false;
            endDrag();
          });
          content.addEventListener('mouseleave', (e) => {
            this.isPointerDown = false;
            endDrag();
          });

          // Hint persists longer; no immediate hide on first interaction
        }
      }

      hide() {
        super.hide();
        this.resetZoom();
        document.body.classList.remove('modal-product-open');
      }

      show(opener) {
        super.show(opener);
        this.initializeMediaItems();
        this.showActiveMedia();
        this.preloadAdjacentImages();
        this.showHint();
        document.body.classList.add('modal-product-open');
        
        // Ensure navigation works on desktop by re-initializing after modal is shown
        setTimeout(() => {
          this.initializeEventListeners();
        }, 100);
      }

      initializeMediaItems() {
        this.mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
        const openedMediaId = this.openedBy.getAttribute('data-media-id');
        this.currentIndex = this.mediaItems.findIndex(item => 
          item.getAttribute('data-media-id') === openedMediaId
        );
        if (this.currentIndex === -1) this.currentIndex = 0;
      }

      showActiveMedia() {
        // Hide all media items
        this.mediaItems.forEach((element) => {
          element.classList.remove('active');
          element.style.display = 'none';
        });

        // Show current media item
        if (this.mediaItems[this.currentIndex]) {
          const activeMedia = this.mediaItems[this.currentIndex];
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          
          activeMedia.classList.add('active');
          activeMedia.style.display = 'flex';

          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          ) {
            activeMedia.loadContent();
          }
        }

        // Update navigation button visibility
        this.updateNavigation();
        this.resetZoom();
      }

      navigate(direction) {
        if (direction === 'next') {
          this.currentIndex = (this.currentIndex + 1) % this.mediaItems.length;
        } else {
          this.currentIndex = this.currentIndex === 0 ? this.mediaItems.length - 1 : this.currentIndex - 1;
        }
        this.showActiveMedia();
        this.preloadAdjacentImages();
      }

      updateNavigation() {
        const prevBtn = this.querySelector('.product-media-modal__nav--prev');
        const nextBtn = this.querySelector('.product-media-modal__nav--next');
        
        if (this.mediaItems.length <= 1) {
          if (prevBtn) prevBtn.style.display = 'none';
          if (nextBtn) nextBtn.style.display = 'none';
        } else {
          if (prevBtn) prevBtn.style.display = 'flex';
          if (nextBtn) nextBtn.style.display = 'flex';
        }
      }

      // Touch and zoom handling
      handleTouchStart(e) {
        if (e.touches.length === 1) {
          this.touchStartX = e.touches[0].clientX;
          this.touchStartY = e.touches[0].clientY;
        } else if (e.touches.length === 2) {
          this.lastTouchDistance = this.getTouchDistance(e.touches[0], e.touches[1]);
        }
      }

      handleTouchMove(e) {
        if (e.touches.length === 2 && this.isZoomed) {
          e.preventDefault();
          const currentDistance = this.getTouchDistance(e.touches[0], e.touches[1]);
          const scaleChange = currentDistance / this.lastTouchDistance;
          this.scale = Math.max(1, Math.min(3, this.scale * scaleChange));
          this.applyZoom();
          this.lastTouchDistance = currentDistance;
        }
      }

      handleTouchEnd(e) {
        // Do not navigate on swipe on touch devices to avoid interfering with zoom/pan
        if (!this.allowSwipeNavigation) return;
        if (e.changedTouches.length === 1 && !this.isZoomed) {
          const touchEndX = e.changedTouches[0].clientX;
          const touchEndY = e.changedTouches[0].clientY;
          const deltaX = this.touchStartX - touchEndX;
          const deltaY = this.touchStartY - touchEndY;

          // Only navigate if it's a horizontal swipe and not vertical
          if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 50) {
            if (deltaX > 0) {
              this.navigate('next');
            } else {
              this.navigate('prev');
            }
          }
        }
      }

      getTouchDistance(touch1, touch2) {
        const dx = touch1.clientX - touch2.clientX;
        const dy = touch1.clientY - touch2.clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }

      toggleZoom(e) {
        // Disable programmatic zoom toggling on touch devices (mobile)
        const isTouchEnv = window.matchMedia('(pointer: coarse)').matches || 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        if (isTouchEnv) return;
        const activeImg = this.getActiveImage();
        if (!activeImg) return;
        
        if (this.isZoomed) {
          this.resetZoom();
        } else {
          this.scale = 2;
          this.isZoomed = true;
          this.tx = 0;
          this.ty = 0;
          this.applyZoom();
          
          // Change cursor to indicate zoom state
          activeImg.style.cursor = 'zoom-out';
        }
      }

      applyZoom() {
        const activeImg = this.getActiveImage();
        if (activeImg) {
          activeImg.style.transform = `translate(${this.tx}px, ${this.ty}px) scale(${this.scale})`;
          activeImg.style.transformOrigin = 'center center';
          activeImg.style.transition = 'transform 0.3s ease';
          activeImg.style.cursor = this.scale > 1 ? 'zoom-out' : 'zoom-in';
        }
      }

      resetZoom() {
        this.scale = 1;
        this.isZoomed = false;
        this.tx = 0;
        this.ty = 0;
        const activeImg = this.getActiveImage();
        if (activeImg) {
          activeImg.style.transform = 'scale(1)';
          activeImg.style.cursor = 'zoom-in';
        }
      }

      clampPan() {
        const content = this.querySelector('.product-media-modal__content');
        const img = this.getActiveImage();
        if (!content || !img) return;
        const contentRect = content.getBoundingClientRect();
        const imgRect = img.getBoundingClientRect();
        // Approximate available overflow based on scaled size
        const displayedWidth = imgRect.width / this.scale; // original displayed width before scale
        const displayedHeight = imgRect.height / this.scale;
        const scaledWidth = displayedWidth * this.scale;
        const scaledHeight = displayedHeight * this.scale;
        const maxOffsetX = Math.max(0, (scaledWidth - contentRect.width) / 2);
        const maxOffsetY = Math.max(0, (scaledHeight - contentRect.height) / 2);
        this.tx = Math.max(-maxOffsetX, Math.min(maxOffsetX, this.tx));
        this.ty = Math.max(-maxOffsetY, Math.min(maxOffsetY, this.ty));
      }

      getActiveImage() {
        const active = this.querySelector('[data-media-id].active');
        if (!active) return null;
        if (active.tagName && active.tagName.toUpperCase() === 'IMG') return active;
        return active.querySelector('img');
      }

      zoomInAt(cx, cy) {
        // cx, cy are coordinates relative to content center
        const prevScale = this.scale || 1;
        this.scale = Math.min(3, Math.max(1.5, prevScale === 1 ? 2 : prevScale + 0.5));
        this.isZoomed = true;
        // Adjust pan to zoom towards click point
        const factor = this.scale / prevScale;
        this.tx = (this.tx - cx) * factor + cx;
        this.ty = (this.ty - cy) * factor + cy;
        this.clampPan();
        this.applyZoom();
      }

      showHint() {
        const hint = this.querySelector('.product-media-modal__hint');
        if (!hint) return;
        hint.classList.add('visible');
        if (this.hintHideTimeout) clearTimeout(this.hintHideTimeout);
        this.hintHideTimeout = setTimeout(() => this.hideHint(), 12000);
      }

      hideHint() {
        const hint = this.querySelector('.product-media-modal__hint');
        if (!hint) return;
        hint.classList.remove('visible');
      }

      // Preload adjacent images for faster navigation
      preloadAdjacentImages() {
        const preloadIndices = [];
        
        // Preload next image
        if (this.currentIndex < this.mediaItems.length - 1) {
          preloadIndices.push(this.currentIndex + 1);
        }
        
        // Preload previous image
        if (this.currentIndex > 0) {
          preloadIndices.push(this.currentIndex - 1);
        }

        preloadIndices.forEach(index => {
          const mediaItem = this.mediaItems[index];
          if (mediaItem) {
            const img = mediaItem.querySelector('img');
            if (img && img.src && !img.complete) {
              // Create a new image object instead of link preload
              const preloadImg = new Image();
              preloadImg.src = img.src;
            }
          }
        });
      }
    }
  );
}
